import React from 'react'
import { Label } from 'react-bootstrap'

class VoteStatus extends React.Component {
	render() {
		if (this.props.value && this.props.value.code) {
			var statusCode = this.props.value.code.toUpperCase();
			var description = this.props.value.description;
			let bg = 'default';
			let type = 'default';

			const greenStatus = ["APR"];
			const redStatus = ["DNY"];

			if (greenStatus.includes(statusCode)) {
				bg = '#43d162';
				type = '#000000';
			}
			else if (redStatus.includes(statusCode)) {
				bg = '#ba1111';
				type = '#FFFFFF';
			}

			return (<b><Label style={{ backgroundColor: bg, color: type, display: "block", padding: "0.45em 1.25em 0.57em" }}>
				{description}
			</Label></b>);
		}
		else
			return <Label></Label>;
	}
}


export default VoteStatus;



// WEBPACK FOOTER //
// ./src/areas/admin/certification/commReview/votes/VoteStatus.js